<div class="h-0 min-h-full flex-1">
  <table
    mat-table
    [dataSource]="appointments()"
  >
    @if (withName()) {
      <ng-container [matColumnDef]="columnHeaders.CLIENTS_NAME">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          {{ "clients.label.fullName" | translate }}
        </th>
        <td
          *matCellDef="let appointment"
          mat-cell
        >
          <span
            class="cursor-pointer font-bold"
            (click)="redirectToClientsProfile(appointment.id)"
          >
            {{ appointment.userFullName }}
          </span>
        </td>
      </ng-container>
    }

    <ng-container [matColumnDef]="columnHeaders.APPOINTMENT_TYPE">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Тип послуги
      </th>
      <td
        *matCellDef="let appointment"
        mat-cell
      >
        {{ appointment.metadata?.type ? ("medicalServices.prescriptionTypes." + appointment.metadata.type | translate) : "Не вказано" }}
      </td>
    </ng-container>

    <ng-container [matColumnDef]="columnHeaders.APPOINTMENT_NAME">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Назва послуги
      </th>
      <td
        *matCellDef="let appointment"
        mat-cell
        class="max-w-[500px]"
      >
        {{ appointment.metadata.name }}
        @if (appointment.metadata.provider === appointmentProviderType.Unknown) {
          <span class="mx-1 rounded-full border border-warning-500 bg-warning-100 px-0.5 py-0.25 text-xs font-thin text-neutral-500">Ручний</span>
        }
        @if (appointment.metadata.event_place === eventPlaceTypes.Telemedicine) {
          <span class="mx-1 rounded-full border border-success-500 bg-success-100 px-0.5 py-0.25 text-xs font-thin text-neutral-500">Онлайн</span>
        }
        @if (!appointment.hasOwnProperty("contractNumber") && appointment.isPaid === false) {
          <span class="mx-1 rounded-full border border-success-500 bg-success-100 px-0.5 py-0.25 text-xs font-thin text-neutral-500">Тест</span>
        }
      </td>
    </ng-container>

    <ng-container [matColumnDef]="columnHeaders.STATUS">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Статус
      </th>
      <td
        *matCellDef="let appointment"
        mat-cell
      >
        <shared-status
          [statusValue]="appointment.status"
          [statusMessage]="'statuses.appointments.' + appointment.status | translate"
        >
        </shared-status>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="columnHeaders.DATE_TIME">
      <th
        *matHeaderCellDef
        mat-header-cell
        class="cursor-pointer select-none hover:bg-neutral-50"
        (click)="onDateColumnSort()"
      >
        <div class="flex items-center gap-2">
          <span>Дата та час</span>
          @if (!withName()) {
            <div
              class="ml-2 flex flex-col"
              [ngClass]="{ 'text-primary-500': !!currentSortBy }"
            >
              @if (currentSortBy === "appointment_date" && currentSortDirection === "asc") {
                <mat-icon>arrow_upward</mat-icon>
              } @else if (currentSortBy === "appointment_date" && currentSortDirection === "desc") {
                <mat-icon>arrow_downward</mat-icon>
              } @else {
                <mat-icon class="text-neutral-400">import_export</mat-icon>
              }
            </div>
          }
        </div>
      </th>
      <td
        *matCellDef="let appointment"
        mat-cell
      >
        @if (appointment.appointmentDate || appointment.metadata.appointment_full_date) {
          <p>{{ formatDate(appointment.appointmentDate || appointment.metadata.appointment_full_date, true) }}</p>
        } @else if (appointment.metadata.type === "Drugs" && appointment.creationDate) {
          <p class="mb-0">до {{ formatDate(appointment.creationDate, true) }}</p>
        }
      </td>
    </ng-container>

    <ng-container [matColumnDef]="columnHeaders.DOCTORS_NAME">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Спеціалізація та ПІБ лікаря
      </th>
      <td
        *matCellDef="let appointment"
        mat-cell
      >
        <div class="flex flex-col items-start justify-center gap-0.5">
          @if (appointment.metadata.doctor_specialties) {
            <div class="flex items-center gap-1">
              @for (specialty of appointment.metadata.doctor_specialties.split(";"); track $index) {
                <shared-info-badge
                  [text]="specialty"
                  [withBorder]="true"
                ></shared-info-badge>
              }
            </div>
          }
          <span class="font-bold">
            {{ appointment.metadata?.doctor_name }}
          </span>
        </div>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="columnHeaders.ACTIONS">
      <th
        *matHeaderCellDef
        mat-header-cell
        class="w-[150px]"
      >
        Дії
      </th>
      <td
        *matCellDef="let appointment"
        mat-cell
      >
        <div class="flex items-center gap-1">
          <button
            class="flex items-center justify-center rounded-full border-2 border-primary-500 bg-transparent p-1.5 text-primary-500 hover:bg-neutral-100"
            (click)="showAppointmentDetails(appointment)"
          >
            <mat-icon>visibility</mat-icon>
          </button>
          @if (showEditButton(appointment)) {
            <button
              class="flex items-center justify-center rounded-full border-2 border-primary-500 bg-transparent p-1.5 text-primary-500 hover:bg-neutral-100"
              (click)="editManualAppointment(appointment)"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              class="flex items-center justify-center rounded-full border-2 border-error-600 bg-transparent p-1.5 text-error-600 hover:bg-neutral-100"
              (click)="deleteManualAppointment(appointment)"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>
          }
        </div>
      </td>
    </ng-container>

    <tr
      *matHeaderRowDef="columns()"
      mat-header-row
      class="sticky top-0 z-10 border-t border-b-2 border-t-neutral-200 border-b-primary-500"
    ></tr>

    <tr
      *matRowDef="let _; columns: columns()"
      mat-row
      class="odd:bg-primary-100"
    ></tr>

    <tr *matNoDataRow>
      <td
        class="bg-neutral-0 py-6 text-center text-lg text-neutral-500"
        [colSpan]="columns().length"
      >
        <span>Візитів не знайдено</span>
      </td>
    </tr>
  </table>
</div>
